module.exports = __webpack_public_path__ + "static/media/AF.a3e950a4.svg";